module.exports = __webpack_public_path__ + "assets/img/DashboardSettings.59cec514.svg";